__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "automateAP.ui.client";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("axios", "0.21.4", () => (__webpack_require__.e(854).then(() => (() => (__webpack_require__(40854))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(113), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(246)]).then(() => (() => (__webpack_require__(78113))))));
			register("react-router-dom", "6.2.1", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(884), __webpack_require__.e(168)]).then(() => (() => (__webpack_require__(51318))))));
			register("react", "17.0.2", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};